import { render, staticRenderFns } from "./work-idCard-query.vue?vue&type=template&id=42f35bd7"
import script from "./work-idCard-query.vue?vue&type=script&lang=ts"
export * from "./work-idCard-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports